window.alooma = window.alooma || {};
export default window.alooma;



// WEBPACK FOOTER //
// ../globals/alooma.js